import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const userApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/admin/user`;

export const getUsersListThunk = createAsyncThunk(
    "user-list",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${userApiEndPoint}/list`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Registration Fail" }
            )
        }
    }
)
export const changeUserStatusThunk = createAsyncThunk(
    "change-users-status",
    async ({ token, data, userId }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${userApiEndPoint}/update-status/${userId}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Something went wrong"
            )
        }
    }
)
export const updateUserThunk = createAsyncThunk(
    "update-user",
    async ({ token, data, userId }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${userApiEndPoint}/update/${userId}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Something went wrong"
            )
        }
    }
)
export const deleteUserThunk = createAsyncThunk(
    "delete-user",
    async ({ token, userId }, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${userApiEndPoint}/delete/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Something went wrong"
            )
        }
    }
)

export const getUserFullDetailsThunk = createAsyncThunk(
    "get-user-details",
    async ({ token, userId, page = 1, limit = 5, search = "" }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${userApiEndPoint}/details/${userId}?page=${page}&limit=${limit}&search=${search}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Something went wrong"
            )
        }
    }
)
